<template>
  <v-card v-if="transaction.payment">
    <send-code-form
      :is-active.sync="isSendingCode"
      :transaction="transaction.payment"
      @changed="transferCodeSent"
    />
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        Transaction details
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <strong>Address: {{ transaction.payment.address || "N/A" }}</strong>
      <v-spacer></v-spacer>
      <div
        class="d-flex"
        v-if="transaction.payment.status == 'pending' && transaction.has_admin_initiator == true"
      >
        <v-btn
          color="primary"
          class="mr-3"
          @click="isSendingCode = true"
          :disabled="transaction.status !== 'initiated'"
        >
          <v-icon color="light-blue lighten-4">mdi-alert-circle-check</v-icon>
          Confirm OTP
        </v-btn>

        <v-btn
          color="primary"
          class="mr-3"
          @click="resendTransferCode"
          :disabled="transaction.status !== 'initiated'"
        >
          <v-icon color="light-blue lighten-4">mdi-alert-circle-check</v-icon>
          Resend OTP Code
        </v-btn>
      </div>
      <div v-if="transaction.done_at != null">
        <v-btn color="primary" :disabled="transaction.done_at == null" @click="downloadInvoice">
          <v-icon>
            mdi-download
          </v-icon>
          Download receipt
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>

      <div v-if="transaction.payment.status == 'completed'">
        <v-btn
          v-if="showStartTransferBtn"
          color="primary"
          :loading="completingTransfer"
          :disabled="!!transactionKey('started_at', null)"
          @click="startTransfer"
        >
          <v-icon>
            mdi-progress-upload
          </v-icon>
          Start Transfer
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>

      <v-btn
        color="primary"
        :loading="isArchiving"
        v-if="
          (transaction.payment.status == 'verified' && transaction.has_admin_initiator == true) ||
          (transaction.payment.status == 'pending' && transaction.has_admin_initiator == false)
        "
        @click="completePayment"
      >
        <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
        Complete Payment
      </v-btn>

      <v-spacer></v-spacer>
      <v-btn
        v-if="transaction.payment.status == 'completed' || !!transaction.status == 'error'"
        color="primary"
        :loading="isRetrying"
        @click="retryTransfer"
        :disabled="isArchived"
      >
        <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
        Retry Transfer
      </v-btn>
      <v-spacer v-if="transferIsStuck"></v-spacer>
      <v-btn
        color="primary"
        :loading="isArchiving"
        v-if="transaction.payment.status == 'pending'"
        @click="toggleActivity"
      >
        <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
        Archive
      </v-btn>
      <v-btn color="primary" :loading="isRestoring" v-if="isArchived" @click="restorePayment">
        <v-icon color="light-blue lighten-4">mdi-restore</v-icon>
        Restore
      </v-btn>
    </v-toolbar>

    <!-- info -->
    <v-divider />
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <h2 class="subtitle-2 text-uppercase">Info</h2>
        </v-col>
        <v-col cols="12" md="3">
          <key-value title="Payment Id" :value="transactionKey('id')" type="none" />
        </v-col>
        <v-col cols="12" md="3">
          <key-value title="Payment Status" :value="transactionKey('status')" />
        </v-col>

        <v-col cols="12" md="2">
          <key-value title="Type" :value="transaction.payment.type" type="title" />
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Provider" :value="transaction.payment.provider" />
        </v-col>
      </v-row>
    </v-card-text>

    <!-- Recipient -->
    <v-divider />

    <!--dates-->
    <v-divider />
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <h2 class="subtitle-2 text-uppercase">Payment</h2>
        </v-col>
        <v-col cols="12" md="3">
          <key-value title="Started At" :value="transaction.payment.started_at" type="date" />
        </v-col>
        <v-col cols="12" md="3">
          <key-value title="Done At" :value="transactionKey('done_at')" type="date" />
        </v-col>
        <v-col cols="12" md="2">
          <key-value title=" Amount">
            <span class="font-weight-bold primary--text title">
              €{{ transaction.payment.amount }}
            </span>
          </key-value>
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Fee">
            <span class="font-weight-bold primary--text title">
              €{{ transactionKey("applied_fee") | currency }}
            </span>
          </key-value>
        </v-col>
      </v-row>
    </v-card-text>
    <!--dates-->
    <v-divider />
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <h2 class="subtitle-2 text-uppercase">Transfer</h2>
        </v-col>
        <v-col cols="12" md="3">
          <key-value title="Started At" :value="transactionKey('started_at')" type="date" />
        </v-col>
        <v-col cols="12" md="3">
          <key-value title="Done At" :value="transactionKey('done_at')" type="date" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import sendCodeForm from "./sendCodeForm";
export default {
  components: { sendCodeForm },
  props: {
    dataTransaction: {
      required: true,
    },
  },
  data() {
    return {
      transaction: this.dataTransaction,
      isShowingStartForm: false,
      isRetrying: false,
      isSendingCode: false,
      show: true,
      completingTransfer: false,
      isArchived: this.dataTransaction.isArchived || false,
      isArchiving: false,
      isRestoring: false,
    };
  },

  computed: {
    showStartTransferBtn() {
      return (
        this.transaction.payment.provider === "SEPA" ||
        (this.transaction.payment.provider === "SEPA" &&
          this.transaction.payment.status === "completed")
      );
    },

    transferIsStuck() {
      // the payment is currently archieved, them we shouldn't retry
      // the transfer because we may have errors retrieving the payment
      const status = this.transactionKey("status");

      if ((status !== "started" && this.transaction.started_at == null) || status === "error") {
        return true;
      }
      return false;
    },
  },

  methods: {
    transferCodeSent({ message }) {
      this.isSendingCode = false;
      Notify.success(message);
      this.$emit("reloadTransfer");
    },
    async resendTransferCode() {
      const id = this.transaction.payment.id;
      await Notify.confirm(`Do you want to resend Transfer OTP Code?`).then(() => {
        this.$http
          .post(`/api/v1/payments/${id}/resendCode`)
          .then((result) => {
            Notify.success(result.message);
            this.$emit("reloadTransfer");
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    transactionKey(key, defaultValue = null) {
      return this.extractDataKey(this.transaction, key, defaultValue);
    },

    completePayment() {
      const id = this.transaction.payment.id;
      if (!id) {
        return;
      }
      Notify.confirm(`Marking this payment as complete`).then(() => {
        this.$http
          .post(`/api/v1/payments/complete/${id}`)
          .then(() => {
            Notify.success("Transaction has been completed successfully!");
            // this.$router.push({ name: "transfers.index" });
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            // console.error(error);
            Notify.error(error.message, error);
          });
      });
    },
    toggleActivity() {
      const id = this.transaction.payment.id;
      if (!id) {
        return;
      }
      Notify.confirm(`Archieving the transaction will hide it from the list of transactions`).then(
        () => {
          this.isArchiving = true;
          this.$http
            .delete(`/api/v1/payments/${id}`)
            .then(() => {
              Notify.success("Transaction was archived successfully!");
              this.$router.push({ name: "bulktransfers.index" });
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
              this.archived = false;
              // console.error(error);
              Notify.error("Transaction was not archived successfully. Please try again!");
            });
        },
      );
    },
    downloadInvoice() {
      this.processing = true;
      this.$http
        .get(`api/v1/payments/invoices/${this.transaction.payment.id}`, { responseType: "blob" })
        .then((response) => this.convertResponse(response))
        .catch((error) => Notify.errorFromResponse(error, { close: true }))
        .finally(() => {
          this.processing = false;
        });
    },
    convertResponse(response) {
      const blob = new Blob([response], { type: response.type });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice-" + this.transaction.id);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },

    startTransfer() {
      this.completingTransfer = true;
      const method =
        this.transaction.payment.type === "card" ? "startCardTransfer" : "startBankTransfer";
      this.$http
        .post(`api/v1/payments/${this.transactionKey("payment.id")}/${method}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "bulktransfers.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.completingTransfer = false));
    },
    retryTransfer() {
      this.isRetrying = true;
      this.$http
        .get(`api/v1/transactions/bulkTransfers/retry/${this.transactionKey("id")}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "bulktransfers.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRetrying = false));
    },
    restorePayment() {
      this.isRestoring = true;
      this.$http
        .get(`api/v1/payments/restore/${this.transactionKey("payment.id")}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "bulktransfers.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRestoring = false));
    },
  },
};
</script>
